function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _SelfCouponUnitMap, _BusinessCouponUnitMa, _TaskTypesDescMap;

// 任务类型
var CarOwnerTaskTypes;

(function (CarOwnerTaskTypes) {
  CarOwnerTaskTypes[CarOwnerTaskTypes["finish"] = 213] = "finish";
  CarOwnerTaskTypes[CarOwnerTaskTypes["progress"] = 215] = "progress";
})(CarOwnerTaskTypes || (CarOwnerTaskTypes = {}));
/* 自营券类型 */


var ESelfCouponTypes;

(function (ESelfCouponTypes) {
  // 折扣券
  ESelfCouponTypes[ESelfCouponTypes["discount"] = 100] = "discount"; // 立减券

  ESelfCouponTypes[ESelfCouponTypes["minus"] = 3] = "minus"; // 通乘券

  ESelfCouponTypes[ESelfCouponTypes["pass"] = 103] = "pass"; // 预估券

  ESelfCouponTypes[ESelfCouponTypes["estimate"] = 111] = "estimate";
})(ESelfCouponTypes || (ESelfCouponTypes = {}));
/* 第三方商家券类型 */


var EBusinessCouponTypes;

(function (EBusinessCouponTypes) {
  // 代金券
  EBusinessCouponTypes[EBusinessCouponTypes["cash"] = 1] = "cash"; // 折扣券

  EBusinessCouponTypes[EBusinessCouponTypes["discount"] = 2] = "discount"; // 兑换券

  EBusinessCouponTypes[EBusinessCouponTypes["exchange"] = 5] = "exchange";
})(EBusinessCouponTypes || (EBusinessCouponTypes = {})); // 折扣券类型编码


var DISCOUNT_COUPON_TYPE = [ESelfCouponTypes.discount, ESelfCouponTypes.estimate, EBusinessCouponTypes.discount];
var SelfCouponUnitMap = (_SelfCouponUnitMap = {}, _defineProperty(_SelfCouponUnitMap, ESelfCouponTypes.discount, "折"), _defineProperty(_SelfCouponUnitMap, ESelfCouponTypes.estimate, "折"), _defineProperty(_SelfCouponUnitMap, ESelfCouponTypes.minus, "元"), _defineProperty(_SelfCouponUnitMap, ESelfCouponTypes.pass, "元"), _SelfCouponUnitMap);
var BusinessCouponUnitMap = (_BusinessCouponUnitMa = {}, _defineProperty(_BusinessCouponUnitMa, EBusinessCouponTypes.cash, "元"), _defineProperty(_BusinessCouponUnitMa, EBusinessCouponTypes.discount, "折"), _defineProperty(_BusinessCouponUnitMa, EBusinessCouponTypes.exchange, ''), _BusinessCouponUnitMa);
var TaskTypesDescMap = (_TaskTypesDescMap = {}, _defineProperty(_TaskTypesDescMap, CarOwnerTaskTypes.finish, "完单可提现"), _defineProperty(_TaskTypesDescMap, CarOwnerTaskTypes.progress, "发路线可提现"), _TaskTypesDescMap);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var KF_COUPON_ICON = 'https://dpubstatic.udache.com/static/dpubimg/Myk-Y8qT0B/hxz_logo.png'; // 滴滴券默认icon

var DiDi_COUPON_ICON = '';
/**
 * 转换券数据
 * @param   coupon  券信息
 * @param   keys    券属性名数组
 * @param   channel 券来源渠道：kf->花小猪 didi->滴滴 business->第三方商家券 task -> 任务券
 * @returns 标准券结构
 */

function convertCoupon(coupon, keys) {
  var channel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'kf';
  var couponName = coupon[getTargetKey(keys, ['name', 'display_name', 'coupon_name'])] || '';
  var couponIcon = coupon[getTargetKey(keys, ['icon'])] || '';
  var couponDesc = coupon[getTargetKey(keys, ['remark', 'description', 'task_subtitle'])] || '';
  var couponType = coupon[getTargetKey(keys, ['type', 'batchType', 'couponType', 'coupon_type'])] || 0;
  var couponDiscount = coupon[getTargetKey(keys, ['discount'])] || 0;
  var couponExpiredTime = coupon[getTargetKey(keys, ['expire_time', 'end_time'])] || '';
  var taskType = coupon[getTargetKey(keys, ['task_type'])] || '';
  var taskBudgetAmount = coupon['task_budget_amount']; // 自营券->立减券券面额，折扣券最高抵扣值; 三方券->代金券-x元， 折扣券-x折task_budget_amount

  var couponAmt = coupon[getTargetKey(keys, ['amount', 'price_value', 'task_budget_amount'])] || 0; // 最高减x

  var couponMaxAmt = coupon[getTargetKey(keys, ['amount'])] || 0; // 门槛价 满x可用

  var couponMinUsePrice = coupon[getTargetKey(keys, ['cap', 'min_use_price'])] || 0; // 自营券分类：1->滴滴券 2->小猪券

  var selfCouponCategory = coupon[getTargetKey(keys, ['category'])]; // 是否是自营券：花小猪&滴滴

  var isSelfCoupon = function isSelfCoupon(e) {
    return ['kf', 'didi'].includes(e);
  }; // 是否是花小猪券


  var isKfCoupon = channel === 'kf' || selfCouponCategory === 2; // 是否是折扣券

  var isDiscountCoupon = DISCOUNT_COUPON_TYPE.includes(+couponType); // 是否是车主任务

  var isTask = channel === 'task'; // 任务类型

  var taskTypeDesc = TaskTypesDescMap[taskType];
  var amount;

  if (isTask) {
    amount = numToFixed(taskBudgetAmount / 100);
  } else {
    amount = isSelfCoupon(channel) ? isDiscountCoupon ? +couponDiscount / 10 : +couponAmt / 100 : couponAmt;
  }

  return _objectSpread(_objectSpread({}, coupon), {}, {
    couponName: couponName,
    couponIcon: isSelfCoupon(channel) ? isKfCoupon ? KF_COUPON_ICON : DiDi_COUPON_ICON : couponIcon,
    couponDesc: couponDesc,
    couponType: couponType,
    couponAmt: amount,
    couponMaxAmt: isSelfCoupon(channel) ? +couponMaxAmt / 100 : couponMaxAmt,
    couponMinUsePrice: isSelfCoupon(channel) ? +couponMinUsePrice / 100 : couponMinUsePrice,
    couponUnit: isSelfCoupon(channel) ? SelfCouponUnitMap[couponType] : BusinessCouponUnitMap[couponType],
    couponExpiredTime: couponExpiredTime,
    isDiscountCoupon: isDiscountCoupon,
    taskTypeDesc: taskTypeDesc
  });
}
/**
 * 优先获取目标属性名数组中排序靠前的属性名
 * @param   keys   属性名全集数组
 * @param   target 目标属性名数组
 * @returns 唯一属性名
 */


function getTargetKey(keys, target) {
  var res = '';

  for (var i = 0; i < target.length; i++) {
    if (keys.includes(target[i])) {
      res = target[i];
      break;
    }
  }

  return res;
}

function numToFixed(num) {
  if (isNaN(num)) {
    return 'Not a Number';
  }

  return Math.round(num * 100) / 100;
}
/**
 * 格式化能源券结构，输出同三方商家券结构一致
 * @param coupons 能源券数据
 */


function formatEnergyCoupon(coupons) {
  var energyCoupons = coupons.map(function (item) {
    return {
      coupon_name: item.coupon_name,
      description: item.promotion_desc,
      icon: '',
      coupon_type: 1,
      min_use_price: +item.amount / 100,
      price_value: +item.discount / 100,
      end_time: item.valid_period_end_time
    };
  });
  return energyCoupons;
}
/**
 * 格式化车主任务结构
 * @param coupons 车主任务券
 */


function formatCarOwnerTask(coupons) {
  var taskCoupons = coupons.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      coupon_name: item.task_title,
      coupon_type: 1
    });
  });
  return taskCoupons;
}
/**
 * 格式化券数据
 * @param {Array}  source  传入的券数据
 * @param {string} channel 券渠道: kf->花小猪 didi->滴滴 business->第三方商家券 energy->能源券
 * @returns 标准券结构数组
 */


function formatCouponData(source, channel) {
  var coupons = source;
  var finalChannel = channel; // 处理能源券

  if (channel === 'energy') {
    coupons = formatEnergyCoupon(source);
    finalChannel = 'business';
  }

  if (channel === 'task') {
    coupons = formatCarOwnerTask(source);
    finalChannel = 'task';
  }

  var res = coupons.map(function (item) {
    return convertCoupon(item, Object.keys(item), finalChannel);
  });
  return res;
}

export { formatCouponData };
